module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return (_vm.selectedItem.slug || _vm.mode.edit) ? _c('div', [(_vm.selectedItem.slug) ? _c('div', {
    staticClass: "upload-container"
  }, [_c('ic-firebase-upload', {
    ref: "upload",
    staticClass: "upload-btn",
    attrs: {
      "path": "images",
      "max-files": "1",
      "getFileName": _vm.getFileName,
      "storage": _vm.storage
    },
    on: {
      "uploaded": _vm.onUploaded,
      "upload": _vm.onUpload,
      "delete": _vm.onDelete
    }
  }), _vm._v(" "), _c('img', {
    attrs: {
      "src": _vm.previewImage,
      "alt": ""
    }
  })], 1) : _vm._e(), _vm._v(" "), _c('hero-preview', {
    attrs: {
      "item": _vm.selectedItem,
      "previewImage": _vm.previewImage
    }
  })], 1) : _vm._e()
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-37c75ce4"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/ModalSingleArticle.vue
// module id = 649
// module chunks = 1